<template>
  <div class="language-dropdown-v2 dropdown">
    <a href="#" class="dropdown-toggle text-uppercase" :class="togglerClass" data-bs-toggle="dropdown" aria-expanded="false">
      {{ locale }}
    </a>
    <ul class="dropdown-menu dropdown-menu-dark">
      <li>
        <a class="dropdown-item" href="#" @click.prevent="changeLanguage('en')">{{ t("EN") }}</a>
      </li>
      <li>
        <a class="dropdown-item" href="#" @click.prevent="changeLanguage('de')">{{ t("DE") }}</a>
      </li>
      <li>
        <a class="dropdown-item" href="#" @click.prevent="changeLanguage('fr')">{{ t("FR") }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { changeLanguage } from "@/i18n";

defineOptions({
  name: "language-dropdown",
});

defineProps({
  togglerClass: {
    type: String,
    default: "",
  },
});

const { locale, t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
